import SqliteDatabaseModel from "./SqliteDatabaseModel"

import {
  SqliteMessageDataType,
  tableName as messageTableName,
  columMapping as messageColumMapping,
  genStatements as messageGenStatements,
} from "./message.schema"

export let MessageModal: SqliteDatabaseModel<SqliteMessageDataType>

export const initDB = () => {
  // console.log("[expo-sqlite]:initDb")
  MessageModal = new SqliteDatabaseModel<SqliteMessageDataType>({
    tableName: messageTableName,
    columMapping: messageColumMapping,
    genStatements: messageGenStatements,
  })
  MessageModal.run()
}
